const LANGUAGE_KEY = "carthy-language";
const LEGACY_DEFAULT_VERSION_KEY = "carthy-language-default-version";
const LEGACY_ENGLISH_DEFAULT = "english-default-2026-09-03";

function detectBrowserLanguage() {
  const languages = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language || "en"];

  return languages.some((language) => String(language).toLowerCase().startsWith("fr"))
    ? "fr"
    : "en";
}

const storedLanguage = localStorage.getItem(LANGUAGE_KEY);
const legacyDefaultVersion = localStorage.getItem(LEGACY_DEFAULT_VERSION_KEY);

// Première visite : utiliser la langue du navigateur.
// Migration du précédent réglage qui forçait l'anglais : si l'anglais venait de ce
// réglage automatique, on redétecte la langue du navigateur une seule fois.
if (!storedLanguage || (legacyDefaultVersion === LEGACY_ENGLISH_DEFAULT && storedLanguage === "en")) {
  localStorage.setItem(LANGUAGE_KEY, detectBrowserLanguage());
}

// Le choix manuel FR/EN est ensuite conservé dans LANGUAGE_KEY par le sélecteur.
localStorage.removeItem(LEGACY_DEFAULT_VERSION_KEY);
